export function getProjectName() {
  var name = '';
  var date = new Date();
  var today = (`${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`).toString();
  var hours = (`${date.getHours()}-${date.getMinutes() + 1}-${date.getSeconds()}`).toString();

  if (window.fileName === '' || window.fileName === null) {
    name = `signage-image_${today}_${hours}`;
  }
  else {
    name = `${window.fileName}_${today}_${hours}`;
  }

  return name;
}